var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-collapse-item",
    { attrs: { title: "图例" } },
    [
      _c("el-form-item", [
        _c(
          "div",
          { staticClass: "chart-form-item-warp" },
          [
            _c("span", { staticClass: "jz-chart-title-label" }, [
              _vm._v("\n                是否开启\n            "),
            ]),
            _vm._v(" "),
            _c("el-switch", {
              model: {
                value: _vm.config.show,
                callback: function ($$v) {
                  _vm.$set(_vm.config, "show", $$v)
                },
                expression: "config.show",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("el-form-item", [
        _c(
          "div",
          { staticClass: "chart-form-item-warp" },
          [
            _c("span", { staticClass: "jz-chart-title-label" }, [
              _vm._v("\n                位置\n            "),
            ]),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: {
                  placeholder: "请选择",
                  "popper-class": "c-select-style-popper",
                },
                model: {
                  value: _vm.config.position,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "position", $$v)
                  },
                  expression: "config.position",
                },
              },
              _vm._l(_vm.positionOptions, function (option) {
                return _c("el-option", {
                  key: option.value,
                  attrs: { label: option.label, value: option.value },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }